export const COMPONENT_NAME = 'Notification';
